export type Access = 'read' | 'write' | 'delete'
export type ToolStatus = 'pending' | 'running' | 'completed' | 'failed' | 'denied'

export interface ToolCall {
  id: string
  name: string
  displayName: string
  access: Access
  args: Record<string, unknown>
  summary?: string
  status: ToolStatus
  result?: Record<string, unknown> | null
  error?: string | null
}

export interface ChatMessage {
  id: string
  role: 'user' | 'assistant'
  text: string
  tools: ToolCall[]
  /** ISO time it was sent or started */
  at?: string
  streaming?: boolean
  failed?: boolean
}

/** Approval codes the API stores on each function call (models.CallApproval*). */
export const Approval = { Pending: 0, System: 1, Denied: 2, Approved: 3 } as const

// Mirrors the API's tool registry (modules/ai_agent/tool/tools); history
// doesn't store access levels, so calls restored from it look them up here.
export const TOOL_ACCESS: Record<string, Access> = {
  list_companies: 'read',
  get_company: 'read',
  company_history: 'read',
  dashboard_stats: 'read',
  find_settings: 'read',
  create_company: 'write',
  upsert_companies: 'write',
  invite_user: 'write',
  rename_team: 'write',
}

export const titleCase = (name: string) => name.split('_').map((w) => w.charAt(0).toUpperCase() + w.slice(1)).join(' ')
